// Reviewed
import React, { Component, Fragment } from "react";
import axios from "axios";
import { ProductListCategoryURL } from "../../APIServices/ProductListRequest";
import Slider from "react-slick";
import ProductCard from "./ProductCard";

class MangoProducts extends Component {
  constructor() {
    super();
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);

    this.state = {
      Next: function () {
        Slider.slickNext();
      },
      DataList: [],
    };
  }
  next() {
    this.slider.slickNext();
  }
  previous() {
    this.slider.slickPrev();
  }

  componentDidMount() {
    this.SelectProductList();
  }
  SelectProductList = () => {
    axios.get(ProductListCategoryURL("CAT16")).then((res) => {
      this.setState({ DataList: res.data });
    });
  };

  render() {
    let settings = {
      infinite: true,
      speed: 500,
      slidesToShow: 5,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
      ],
    };

    let products = this.state.DataList;

    if (products.length > 0) {
      if (products.length < 6) {
        let i = 0;
        while (products.length < 6) {
          products.push(this.state.DataList[i])
          i++;
        }
      }
    }

    return (
      <>
        <div id="MangoProduct" className="bg-white">
          <div className="container">
            <div className="py-4  py-lg-5 d-flex justify-content-between">
              <h3 className="SectionTitle fw-bold mt-2">আম</h3>
              <div className="CategoryCarousel">
                <button
                  onClick={this.previous}
                  className="prev btn btn-outline-success rounded-circle"
                  style={{ marginRight: "10px" }}
                >
                  <i className="fa-solid fa-angle-left"></i>
                </button>
                <button
                  onClick={this.next}
                  className="prev btn btn-outline-success rounded-circle"
                >
                  <i className="fa-solid fa-angle-right"></i>
                </button>
              </div>
            </div>
            <div className="row">
              <div className="CategoryListItem col-12">
                <Slider ref={(c) => (this.slider = c)} {...settings}>
                  {products.map((product, index) => (
                    <div className="Items" key={index}>
                      <ProductCard product={product} />
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default MangoProducts;
